import { forwardRef } from "react";
import { FiBellOff } from "react-icons/fi";
import Checkbox from "../atoms/Checkbox";
import NotificationItem from "./NotificationItem";

/**
 * Zilin açılır listesi — son bildirimler, "Tümünü okundu işaretle" ve e-posta tercihi.
 * Konumu (fixed) NotificationBell verir.
 */
const NotificationPanel = forwardRef(function NotificationPanel(
  { notifications, isLoading, isError, unreadCount, onOpen, onMarkAll, emailPrefs = [], onToggleEmail, prefsLoading, style, className, onMouseEnter, onMouseLeave },
  ref,
) {
  return (
    <div
      ref={ref}
      role="dialog"
      aria-label="Bildirimler"
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`fixed z-[10200] flex max-h-[70vh] flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-xl ${className || ""}`}
    >
      <div className="flex shrink-0 items-center justify-between gap-3 border-b border-gray-100 px-4 py-3">
        <span className="text-sm font-SemiBold text-gray-900">Bildirimler</span>
        <button
          type="button"
          onClick={onMarkAll}
          disabled={!unreadCount}
          className="text-xs font-Medium text-indigo-600 transition-colors hover:text-indigo-800 disabled:cursor-default disabled:text-gray-300"
        >
          Tümünü okundu işaretle
        </button>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto">
        {isLoading ? (
          <div className="px-4 py-8 text-center text-sm text-gray-400">Yükleniyor...</div>
        ) : isError ? (
          <div className="px-4 py-8 text-center text-sm text-fifth">Bildirimler alınamadı.</div>
        ) : notifications.length === 0 ? (
          <div className="flex flex-col items-center gap-2 px-4 py-10 text-center text-gray-400">
            <FiBellOff className="h-6 w-6" />
            <span className="text-sm font-Medium">Bildirim yok</span>
          </div>
        ) : (
          <ul className="divide-y divide-gray-100">
            {notifications.map((n) => (
              <NotificationItem key={n._id} notification={n} onOpen={onOpen} />
            ))}
          </ul>
        )}
      </div>

      {emailPrefs.length > 0 && (
        <div className="flex shrink-0 flex-col items-end gap-2 border-t border-gray-100 px-4 py-3">
          {emailPrefs.map((pref) => (
            <Checkbox
              key={pref.field}
              label={emailPrefs.length > 1 ? pref.label : "E-posta bildirimleri"}
              checked={pref.checked}
              disabled={prefsLoading}
              onChange={(e) => onToggleEmail(pref.field, e.target.checked)}
            />
          ))}
        </div>
      )}
    </div>
  );
});

export default NotificationPanel;
